<div class="invoice-detail-container">
  <form #form="ngForm">
    <app-invoice-voucher-form [IsReadOnly]="false" [InvoiceDetailModel]="invoiceDetailModel">
    </app-invoice-voucher-form>

    <div class="card section container-fluid col-md-11 justify-content-center" style="z-index: 1000">
      <div class="card-header card-title">Circuit de validation</div>
      <div class="card-header-detail">
        <div class="row">
          <div class="col">
            <div class="form-group-container form-group mx-0 row">
              <label class="col-xs-12 col-md-3 my-auto pl-0" for="Workflow">Circuit de validation</label>
              <div class="col-xs-12 col-md-9 px-0" [formGroup]="workflowForm">
                <ng-container *ngIf="IsSingleWorkflow">
                  <div class="form-control form-control-read">
                    {{ dropDownDataWorkflow[0]?.Name }}
                  </div>
                </ng-container>
                <ng-container *ngIf="!IsSingleWorkflow">
                  <ng-multiselect-dropdown placeholder='Sélectionner' [ngClass]="{ 'is-invalid': submitted && !IsWorkflowFormValid }" [settings]="dropDownSettingsWorkflow"
                    [data]="dropDownDataWorkflow" formControlName="Workflow" ngDefaultControl [(ngModel)]="selectedWorkflow">
                  </ng-multiselect-dropdown>
                  <div *ngIf="submitted && !IsWorkflowFormValid" class="invalid-feedback">
                    <span *ngIf="!IsWorkflowFormValid">
                      Veuillez saisir le Circuit de validation
                    </span>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <section class="bottom-bar">
      <div fxLayout=”row” fxLayoutAlign="end">
        <div class="btnSpacerCol">
          <ng-container *ngTemplateOutlet="goBackDetails"></ng-container>
        </div>
        <div class="btnSpacerCol">
          <ng-container *ngTemplateOutlet="validate"></ng-container>
        </div>
      </div>
    </section>
  </form>
</div>

<ng-template #goBackDetails>
  <button mat-stroked-button class="currentBtn" tooltip="Retour" (click)="goBackToInvoiceList()">
    <mat-icon>keyboard_return</mat-icon>
    <span>Retour</span>
  </button>
</ng-template>

<ng-template #validate>
  <button mat-stroked-button class="currentBtnColor" tooltip="Traiter la facture" [disabled]="!(AreFormsValid)" (click)="onSubmit()">
    <mat-icon>check_circle_outline</mat-icon>
    <span fxHide fxShow.gt-md class="currentBtnDetailColor">Valider
    </span>
  </button>
</ng-template>